var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.005 0H19.995C8.9675 0 0 8.97 0 20C0 24.375 1.41 28.43 3.8075 31.7225L1.315 39.1525L9.0025 36.695C12.165 38.79 15.9375 40 20.005 40C31.0325 40 40 31.0275 40 20C40 8.9725 31.0325 0 20.005 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6424 28.2434C31.1599 29.6059 29.2449 30.7359 27.7174 31.0659C26.6724 31.2884 25.3074 31.4659 20.7124 29.5609C14.8349 27.1259 11.0499 21.1534 10.7549 20.7659C10.4724 20.3784 8.37988 17.6034 8.37988 14.7334C8.37988 11.8634 9.83738 10.4659 10.4249 9.86594C10.9074 9.37344 11.7049 9.14844 12.4699 9.14844C12.7174 9.14844 12.9399 9.16094 13.1399 9.17094C13.7274 9.19594 14.0224 9.23094 14.4099 10.1584C14.8924 11.3209 16.0674 14.1909 16.2074 14.4859C16.3499 14.7809 16.4924 15.1809 16.2924 15.5684C16.1049 15.9684 15.9399 16.1459 15.6449 16.4859C15.3499 16.8259 15.0699 17.0859 14.7749 17.4509C14.5049 17.7684 14.1999 18.1084 14.5399 18.6959C14.8799 19.2709 16.0549 21.1884 17.7849 22.7284C20.0174 24.7159 21.8274 25.3509 22.4749 25.6209C22.9574 25.8209 23.5324 25.7734 23.8849 25.3984C24.3324 24.9159 24.8849 24.1159 25.4474 23.3284C25.8474 22.7634 26.3524 22.6934 26.8824 22.8934C27.4224 23.0809 30.2799 24.4934 30.8674 24.7859C31.4549 25.0809 31.8424 25.2209 31.9849 25.4684C32.1249 25.7159 32.1249 26.8784 31.6424 28.2434Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c5956e0e.svg";
export { ForwardRef as ReactComponent };